<template>
  <div class="achievement-item">
    <div class="header-title">
      <div class="title">
        {{ achievementItem.title }}/{{ achievementItem.subTitle }}
      </div>
      <div class="grade-info">
        <span class="grade">{{ achievementItem.gradeName }}</span>
        <span>{{ achievementItem.outsideSchoolSign }}</span>
      </div>
    </div>
    <!-- 分割线 -->
    <el-divider></el-divider>
    <div class="footer-score">
      <div class="score-title">各科平均分</div>
      <div class="score-list">
        <el-tag
          v-for="item in achievementItem.scoreInfoList"
          :key="item.courseId"
          effect="plain"
          class="score-item"
        >
          {{ item.courseName }}/{{ item.avgScore }}
        </el-tag>
      </div>
    </div>
    <div class="del-btn" v-hasPermi="'sc:externalachievement:edit'">
      <el-button
        type="text"
        style="color: #0066cc !important"
        @click="editExternal"
        >编辑</el-button
      >
      <el-button
        type="text"
        style="color: #fc3e39 !important"
        @click="delExternal"
        >删除</el-button
      >
    </div>
  </div>
</template>

<script>
export default {
  props: ["achievementItem"],
  inject: ["refresh"],
  data() {
    return {};
  },
  methods: {
    editExternal() {
      // console.log("achievementItem：", this.achievementItem);
      this.$emit("editClick", this.achievementItem);
    },
    delExternal() {
      // console.log("this.achievementItem:", this.achievementItem);
      this.$confirm("是否删除当前校外成绩?", "删除校外成绩", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        confirmButtonClass: "confirm",
      })
        .then(() => {
          this.delete(
            this.$url.delExternalAchievement +
              "?examInfoId=" +
              this.achievementItem.examInfoId +
              "&outsideSchoolSign=" +
              this.achievementItem.outsideSchoolSign
          ).then((res) => {
            if (res.code !== 200)
              return this.$message.error(res.msg || "删除失败");
            this.$message.success(res.msg || "删除成功");
            // 刷新校外成绩列表
            this.refresh();
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./achievement-item.scss";
</style>
